import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import LoginModal from "../components/Modals/LoginModal";
import { useAuth } from "../contexts/JWTContext";
import RegisterModal from "../components/Auth/RegisterModal";
import styles from "./Login.module.css";

const Login = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isInitialized } = useAuth();
  const [showRegister, setShowRegister] = useState(false);

  const openRegister = useCallback(() => {
    setShowRegister(true);
  }, []);

  const openLogin = useCallback(() => {
    setShowRegister(false);
  }, []);

  useEffect(() => {
    if (!isInitialized) return;
    if (isAuthenticated) {
      const activeEl = document.activeElement;
      if (
        activeEl instanceof HTMLElement &&
        (activeEl.tagName === "INPUT" ||
          activeEl.tagName === "TEXTAREA" ||
          activeEl.tagName === "SELECT" ||
          activeEl.isContentEditable)
      ) {
        activeEl.blur();
      }

      const viewportMeta = document.querySelector('meta[name="viewport"]');
      if (viewportMeta) {
        viewportMeta.setAttribute(
          "content",
          "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover",
        );
      }

      window.requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      });

      navigate("/menu", { replace: true });
    }
  }, [isAuthenticated, isInitialized, navigate]);

  return (
    <div className={styles.loginPage}>
      {!showRegister && (
        <LoginModal
          isOpen
          onClose={() => {}}
          onOpenRegister={openRegister}
          hideClose
        />
      )}
      {showRegister && (
        <RegisterModal
          onClose={openLogin}
          onSwitchToLogin={openLogin}
          hideClose
        />
      )}
    </div>
  );
};

export default Login;
